<template>
    <div style="width: 500px">
        <el-upload class="upload" ref="upload" :action="$fileUpLoadUrl"
         :on-preview="handlePreview"
         :on-remove="handleRemove" :limit="limit" :before-remove="beforeRemove" multiple :on-exceed="handleExceed" 
         :on-success="handleSuccess" :on-change="handleChange" :headers="headers" :file-list="fileList" :data="{ path: status }">
            <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            default: 'xlsupload' //Receipt
        },
        resList: {
            type: Array,
            default: () => []
        },
        limit: {
            type: Number,
            default: 100
        }
    },
    data() {
        return {
            filePath: '',
            headers: {},
            fileList: this.resList,
            templist: [],
            uploadingFiles: [] // 记录正在上传的文件
        };
    },
    methods: {
        handleRemove(file, fileList) {
            const removedFileIndex = fileList.findIndex((f) => f.uid === file.uid);
            if (removedFileIndex !== -1) {
                this.templist.splice(removedFileIndex, 1);
            }
            this.fileList = fileList;
        },
        handlePreview(file) {
            window.open(this.$openFileUrl + file.response.data);
        },
        handleExceed(files, fileList) {
            console.log(files, fileList);
        },
        beforeRemove(file, fileList) {
            console.log(file);
        },
        handleSuccess(response, file, fileList) {
            console.log(response, file, fileList);
            if (response.Resultcode === 0) {
                this.templist.push(response.data + '$' + file.name);
                this.fileList = fileList;
                
                // 从上传中列表移除该文件
                const index = this.uploadingFiles.findIndex(f => f.uid === file.uid);
                if (index !== -1) {
                    this.uploadingFiles.splice(index, 1);
                }
                
                // 检查是否所有文件都上传完成
                if (this.uploadingFiles.length === 0) {
                    // 所有文件上传完成，触发完成逻辑
                    this.autoSubmitUpload();
                }
            } else {
                this.$message({
                    message: '上传失败',
                    type: 'error'
                });
                
                // 从上传中列表移除该文件（即使失败也要移除）
                const index = this.uploadingFiles.findIndex(f => f.uid === file.uid);
                if (index !== -1) {
                    this.uploadingFiles.splice(index, 1);
                }
            }
        },
        autoSubmitUpload() {
            this.$emit('ontempList', this.templist);
            this.$message({
                message: '文件上传成功',
                type: 'success'
            });
        },
        
        handleChange(file, fileList) {
            if (file.status === 'ready') {
                this.uploadingFiles.push(file);
            }
        }
    }
};
</script>

<style>
</style>